import { action, observable } from "mobx";
import { ApiService, ApiUrl, Constants } from "helpers";
import { fixBeeIconTelLinks } from "helpers/beeIconTelFix";
import Alert from "react-s-alert";
import { campaignStore } from "stores";
import { FilterModelPageName, HeaderTabName } from "helpers/Constants";
import { FormatDate } from "helpers";

//TODO: refactor to use mobx correctly, actions, computed etc , not all one big observable
const emailStore = observable({
  isFormDirty: false,
  id: undefined,
  isUpdatedCampaignName: false,
  campaignName: "",
  previousCampaignName: "",
  description: "",
  jsonTemplate: undefined,
  htmlTemplate: undefined,
  emailTemplatesList: [],
  emailsList: [],
  filteredEmailsList: [],
  filteredEmailTemplatesList: [],
  beeEditor: undefined,
  onNextChange: null,
  tempTemplateJsonData: undefined,
  tempTemplateHtmlData: undefined,
  isDisabledSaveButton: true, // default value
  isUseEmailTemplate: false,
  isEditTemplate: false,
  activeTab: null,
  tagCategories: [],
  isUpdateCampaignName: false,
  fromAutomation: false,
  isSendTestEmail: false,
  isSaveToTemplate: false,
  activeGrid: HeaderTabName.TAB_EMAIL_GRID_TEMPLATE,
  forceUpdate: false,
  isCopyToExisting: false,
  sourceId: undefined,
  isFromCopyToExisting: false,
  sourceTid: undefined,
  EmailFilters: {},
  filterSearchText: "",
  originalCampaignName: "",
  emailBuilderLoading: false,
  isBeeSendTestDisabled: false,

  // Bee templates state
  beeTemplates: [],
  beeTemplatesLoading: false,
  beeTemplatesError: null,
  beeTemplatesPage: 1,
  beeTemplatesTotalCount: 0,
  beeTemplatesNext: null,
  beeTemplatesPrevious: null,
  beeTemplatesFacets: {},
  selectedBeeTemplateCategories: [],

  // Bee categories state
  beeCategories: [],
  beeCategoriesLoading: false,
  beeCategoriesError: null,
  selectedCategories: [],
  searchTerm: "",
  templateDefaultLandingPageTab: HeaderTabName.TAB_EMAIL_EDITOR_TEMPLATE,

  setEmailFilters(data) {
    this.EmailFilters = data;
    sessionStorage.setItem(
      FilterModelPageName.EmailsPage,
      JSON.stringify(data)
    );
  },
  setForceUpdate(forceUpdate) {
    this.forceUpdate = forceUpdate;
  },
  setIsUpdatedCampaignName(isUpdatedCampaignName) {
    this.isUpdatedCampaignName = isUpdatedCampaignName;
  },
  setIsSaveToTemplate(isSaveToTemplate) {
    this.isSaveToTemplate = isSaveToTemplate;
  },
  setFromAutomation(fromAutomation) {
    this.fromAutomation = fromAutomation;
  },
  setIsSendTestEmail(isSendTestEmail) {
    this.isSendTestEmail = isSendTestEmail;
  },
  setIsUpdateCampaignName(isUpdateCampaignName) {
    this.isUpdateCampaignName = isUpdateCampaignName;
  },
  setIsUseEmailTemplate(isUseEmailTemplate) {
    this.isUseEmailTemplate = isUseEmailTemplate;
  },
  setIsEditTemplate(isEditTemplate) {
    this.isEditTemplate = isEditTemplate;
  },
  setIsDisabledEditorSaveButton(isDisabledSaveButton) {
    this.isDisabledSaveButton = isDisabledSaveButton;
  },
  setTempTemplateJsonData(jsonData) {
    this.tempTemplateJsonData = jsonData;
  },
  setTempTemplateHtmlData(htmlData) {
    this.tempTemplateHtmlData = htmlData;
  },
  setOriginalCampaignName(name) {
    this.originalCampaignName = name;
  },

  setEmailsSearchString(searchString) {
    const { FormatDateUtc } = FormatDate;

    const ApplySearchStringIfUpdatedDateExists = item =>
      !!item?.updatedAt &&
      FormatDateUtc(item?.updatedAt)
        .substring(0, 11)
        .toLowerCase()
        .includes(searchString.toLowerCase())
        ? true
        : false;

    this.filterSearchText = searchString;

    this.filteredEmailsList = this.emailsList.filter(
      item =>
        ApplySearchStringIfUpdatedDateExists(item) ||
        item.name.toLowerCase().includes(searchString.toLowerCase()) ||
        item.category?.toLowerCase().includes(searchString.toLowerCase()) ||
        item.updatedBy?.toLowerCase().includes(searchString.toLowerCase())
    );
  },

  setEmailTemplatesSearchString(searchString) {
    const { FormatDateUtc } = FormatDate;

    const ApplySearchStringIfUpdatedDateExists = item =>
      !!item?.updatedAt &&
      FormatDateUtc(item?.updatedAt)
        .substring(0, 11)
        .toLowerCase()
        .includes(searchString.toLowerCase())
        ? true
        : false;

    this.filterSearchText = searchString;

    this.filteredEmailTemplatesList = this.emailTemplatesList.filter(
      item =>
        ApplySearchStringIfUpdatedDateExists(item) ||
        item.description?.toLowerCase().includes(searchString.toLowerCase()) ||
        item.name.toLowerCase().includes(searchString.toLowerCase()) ||
        item.category?.toLowerCase().includes(searchString.toLowerCase()) ||
        item.updatedBy?.toLowerCase().includes(searchString.toLowerCase())
    );
  },

  setEmailBuilderLoading(emailBuilderLoading) {
    this.emailBuilderLoading = emailBuilderLoading;
  },
  setIsBeeSendTestDisabled(isBeeSendTestDisabled) {
    this.isBeeSendTestDisabled = isBeeSendTestDisabled;
  },

  clearTemplateData() {
    this.tempTemplateHtmlData = undefined;
    this.tempTemplateJsonData = undefined;
  },

  clearFormData() {
    this.id = undefined;
    this.isUpdatedCampaignName = false;
    this.campaignName = "";
    this.previousCampaignName = "";
    this.description = "";
    this.jsonTemplate = undefined;
    this.htmlTemplate = undefined;
    this.isFormDirty = false;
    this.isDisabledSaveButton = true;
    this.isUseEmailTemplate = false;
    this.isEditTemplate = false;
    this.tagCategories = [];
    this.activeTab = null;
    this.isUpdateCampaignName = false;
    this.fromAutomation = false;
    this.isSaveToTemplate = false;
    this.forceUpdate = false;
    this.originalCampaignName = "";
    this.onNextChange = null;
    this.isBeeSendTestDisabled = false;
  },

  setFormData(data) {
    this.id = data.id;
    this.campaignName = data.name ? data.name : data.campaignName;
    this.originalCampaignName = this.campaignName;
    this.previousCampaignName = this.campaignName;
    this.description = data.description;
    const fixed = fixBeeIconTelLinks(data.jsonTemplate, data.htmlTemplate);
    this.jsonTemplate = fixed.jsonTemplate;
    this.htmlTemplate = fixed.htmlTemplate;
    if (data.tagCategories !== undefined) {
      this.setTagCategories(
        JSON.parse(data.tagCategories).map(item => {
          return {
            label: item,
            value: item
          };
        }),
        false
      );
    }
    this.isFormDirty = false;
    this.isUpdateCampaignName = false;
    this.isUpdatedCampaignName = false;
  },

  setIsFormDirty(isFormDirty) {
    this.isFormDirty = isFormDirty;
  },

  setId(id) {
    this.id = id;
  },

  setCampaignName(campaignName) {
    this.campaignName = campaignName;
    this.setIsUpdateCampaignName(true);
    this.setIsFormDirty(true);
  },

  setPreviousCampaignName(previousCampaignName) {
    this.previousCampaignName = previousCampaignName;
  },

  setTagCategories(tagCategories, setDirty = true) {
    this.tagCategories = [];
    this.tagCategories = [...tagCategories];
    if (setDirty) {
      this.setIsFormDirty(true);
    }
  },

  setDescription(description) {
    this.description = description;
    this.setIsFormDirty(true);
  },

  setJsonTemplate(jsonTemplate) {
    this.jsonTemplate = jsonTemplate;
  },

  setHtmlTemplate(htmlTemplate) {
    this.htmlTemplate = htmlTemplate;
  },

  setEmailTemplateList(emailTemplateList) {
    this.emailTemplatesList = emailTemplateList;
    this.filteredEmailTemplatesList = emailTemplateList;
  },

  setEmailExistingList(emailExistingList) {
    this.emailsList = emailExistingList;
    this.filteredEmailsList = emailExistingList;
    this.EmailFilters = {};
  },

  setBeeEditor(beeEditor) {
    this.beeEditor = beeEditor;
  },

  setOnNextChange(fn) {
    this.onNextChange = fn;
  },

  setActiveTab(activeTab) {
    this.activeTab = activeTab;
  },

  setActiveGrid(activeGrid) {
    this.activeGrid = activeGrid;
  },

  setIsCopyToExisting(isCopyToExisting) {
    this.isCopyToExisting = isCopyToExisting;
  },

  setSourceId(sourceId) {
    this.sourceId = sourceId;
  },

  setIsFromCopyToExisting(isFromCopyToExisting) {
    this.isFromCopyToExisting = isFromCopyToExisting;
  },

  setSourceTid(sourceTid) {
    this.sourceTid = sourceTid;
  },

  // Bee templates actions
  setBeeTemplates(items) {
    this.beeTemplates = items;
  },
  setBeeTemplatesLoading(value) {
    this.beeTemplatesLoading = value;
  },
  setBeeTemplatesError(value) {
    this.beeTemplatesError = value;
  },
  setBeeTemplatesPage(value) {
    this.beeTemplatesPage = value;
  },
  setBeeTemplatesTotalCount(value) {
    this.beeTemplatesTotalCount = value;
  },
  setBeeTemplatesNext(value) {
    this.beeTemplatesNext = value;
  },
  setBeeTemplatesPrevious(value) {
    this.beeTemplatesPrevious = value;
  },
  setBeeTemplatesFacets(value) {
    this.beeTemplatesFacets = value;
  },
  setSelectedBeeTemplateCategories(items) {
    this.selectedBeeTemplateCategories = items;
  },

  // Bee categories setters
  setBeeCategories(categories) {
    this.beeCategories = categories;
  },
  setBeeCategoriesLoading(loading) {
    this.beeCategoriesLoading = loading;
  },
  setBeeCategoriesError(error) {
    this.beeCategoriesError = error;
  },
  setSelectedCategories(categories) {
    this.selectedCategories = categories;
  },
  setSearchTerm(term) {
    this.searchTerm = term;
  },

  setTemplateDefaultLandingPageTab(tab) {
    this.templateDefaultLandingPageTab = tab;
  },

  getEmailTemplates() {
    return ApiService.get(
      ApiUrl.getListEmailTemplate,
      "",
      Constants.ALERT_FETCH_FAILED
    )
      .then(
        action(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            this.setEmailTemplateList(response.data.result);
          } else {
            Alert.error("Oops, Something went wrong! Please try again.");
          }
          return Promise.resolve(response);
        })
      )
      .catch(
        action(error => {
          return Promise.reject(error);
        })
      );
  },

  getEmails() {
    return ApiService.get(
      ApiUrl.getListEmailCampaign,
      "",
      Constants.ALERT_FETCH_FAILED
    )
      .then(
        action(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            this.setEmailExistingList(response.data.result);
          } else {
            Alert.error("Oops, Something went wrong! Please try again.");
          }
          return Promise.resolve(response);
        })
      )
      .catch(
        action(error => {
          return Promise.reject(error);
        })
      );
  },

  getEmailTemplateDetail() {
    return ApiService.getDetail(ApiUrl.getEmailTemplateDetail, this.id)
      .then(
        action(response => {
          let data = response.data;
          if (
            response &&
            response.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            if (this.isSendTestEmail) {
              data.result.campaignName =
                campaignStore.emailTemplate.campaignName;
              data.result.htmlTemplate =
                campaignStore.emailTemplate.htmlTemplate;
              data.result.jsonTemplate =
                campaignStore.emailTemplate.jsonTemplate;
              data.result.description = campaignStore.emailTemplate.description;
              data.result.category = campaignStore.emailTemplate.category;
              data.result.id = campaignStore.emailTemplate.id;
              this.tempTemplateJsonData =
                campaignStore.emailTemplate.jsonTemplate;
              this.tempTemplateHtmlData =
                campaignStore.emailTemplate.htmlTemplate;
              this.isSendTestEmail = false;
            }
            this.setFormData(data.result);
          } else {
            Alert.error("Oops, Something went wrong! Please try again.");
          }

          return Promise.resolve(data);
        })
      )
      .catch(
        action(err => {
          return Promise.reject(err);
        })
      );
  },

  getEmailCampaignDetail() {
    return ApiService.getDetail(ApiUrl.getEmailCampaignDetail, this.id)
      .then(
        action(response => {
          let data = response.data;
          if (
            response &&
            response.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            if (this.isSendTestEmail) {
              data.result.campaignName =
                campaignStore.emailTemplate.campaignName;
              data.result.htmlTemplate =
                campaignStore.emailTemplate.htmlTemplate;
              data.result.jsonTemplate =
                campaignStore.emailTemplate.jsonTemplate;
              data.result.description = campaignStore.emailTemplate.description;
              data.result.category = campaignStore.emailTemplate.category;
              data.result.id = campaignStore.emailTemplate.id;
              this.tempTemplateJsonData =
                campaignStore.emailTemplate.jsonTemplate;
              this.tempTemplateHtmlData =
                campaignStore.emailTemplate.htmlTemplate;
              this.isSendTestEmail = false;
            }
            this.setFormData(data.result);
          } else {
            Alert.error("Oops, Something went wrong! Please try again.");
          }
          return Promise.resolve(data);
        })
      )
      .catch(
        action(err => {
          return Promise.reject(err);
        })
      );
  },

  deleteEmailTemplate(id) {
    return ApiService.remove(ApiUrl.deleteEmailTemplate, id)
      .then(
        action(response => {
          this.getEmailTemplates();
          return Promise.resolve(response.data);
        })
      )
      .catch(
        action(err => {
          return Promise.reject(err);
        })
      );
  },

  deleteEmailExisting(id) {
    return ApiService.remove(ApiUrl.deleteEmailCampaign, id)
      .then(
        action(response => {
          this.getEmails();
          return Promise.resolve(response.data);
        })
      )
      .catch(
        action(err => {
          return Promise.reject(err);
        })
      );
  },

  submit() {
    if (this.isSaveToTemplate) {
      return this.submitTemplate();
    }
    const fixed = fixBeeIconTelLinks(this.jsonTemplate, this.htmlTemplate);
    this.jsonTemplate = fixed.jsonTemplate;
    this.htmlTemplate = fixed.htmlTemplate;
    const data = {
      name: this.campaignName,
      jsonTemplate: this.jsonTemplate,
      htmlTemplate: this.htmlTemplate,
      description: this.description,
      category: JSON.stringify([
        ...new Set(
          this.tagCategories.map(item => {
            return item.value;
          })
        )
      ])
    };
    if (this.id && !this.isUseEmailTemplate && !this.isCopyToExisting) {
      return this.update(data).then(response => {
        if (response && !response.isError) {
          this.setOriginalCampaignName(this.campaignName);
        }
        return response;
      });
    } else if (this.id && !this.isUseEmailTemplate && this.isCopyToExisting) {
      return this.createTemplate(data);
    } else {
      return this.create(data).then(response => {
        if (response && !response.isError) {
          this.setOriginalCampaignName(this.campaignName);
        }
        return response;
      });
    }
  },

  submitTemplate() {
    const fixed = fixBeeIconTelLinks(this.jsonTemplate, this.htmlTemplate);
    this.jsonTemplate = fixed.jsonTemplate;
    this.htmlTemplate = fixed.htmlTemplate;
    const data = {
      name: this.campaignName,
      jsonTemplate: this.jsonTemplate,
      htmlTemplate: this.htmlTemplate,
      description: this.description,
      category: JSON.stringify(
        this.tagCategories.map(item => {
          return item["value"];
        })
      )
    };

    if (this.id && !this.isUseEmailTemplate && this.isEditTemplate) {
      return this.updateTemplate(data);
    } else {
      return this.createTemplate(data);
    }
  },

  create(data = {}) {
    data.htmlTemplate = data.htmlTemplate.replace(
      /<code[^>]*>(.*?)<\/code>/g,
      "$1"
    );
    return ApiService.add(ApiUrl.addEmailCampaign, data)
      .then(
        action(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            this.id = response.data.result.id;
            this.isFormDirty = false;
            this.isUseEmailTemplate = false;
            window.history.pushState(
              "",
              "",
              `/admin/emails/editor/${response.data.result.id}`
            );
          } else {
            Alert.error("Oops, Something went wrong! Please try again.");
          }
          return Promise.resolve(response.data);
        })
      )
      .catch(
        action(error => {
          return Promise.reject(error);
        })
      );
  },

  update(data = {}) {
    const newData = {
      ...data,
      id: this.id,
      forceUpdate: this.forceUpdate
    };
    newData.htmlTemplate = newData.htmlTemplate.replace(
      /<code[^>]*>(.*?)<\/code>/g,
      "$1"
    );
    return ApiService.edit(ApiUrl.updateEmailCampaign, newData)
      .then(
        action(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            this.isFormDirty = false;
          } else {
            Alert.error("Oops, Something went wrong! Please try again.");
          }
          return Promise.resolve(response.data);
        })
      )
      .catch(
        action(error => {
          return Promise.reject(error);
        })
      );
  },

  createTemplate(data = {}) {
    const url = this.isSaveToTemplate
      ? ApiUrl.copyEmailToTemplate
      : ApiUrl.copyEmailToExisting;
    return ApiService.add(url, data)
      .then(
        action(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            this.isFormDirty = false;
          } else {
            Alert.error("Oops, Something went wrong! Please try again.");
          }
          return Promise.resolve(response.data);
        })
      )
      .catch(
        action(error => {
          return Promise.reject(error);
        })
      );
  },

  updateTemplate(data = {}) {
    const newData = {
      ...data,
      id: this.id
    };

    return ApiService.edit(ApiUrl.updateEmailTemplate, newData)
      .then(
        action(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            this.isFormDirty = false;
          } else {
            Alert.error("Oops, Something went wrong! Please try again.");
          }
          return Promise.resolve(response.data);
        })
      )
      .catch(
        action(error => {
          return Promise.reject(error);
        })
      );
  },

  isExistEmailCampaignInAutomation(id) {
    return ApiService.getDetail(ApiUrl.IsEmailCampaignUsedInAutomation, id)
      .then(
        action(response => {
          return Promise.resolve(response.data);
        })
      )
      .catch(
        action(err => {
          return Promise.reject(err);
        })
      );
  },

  toggleShowToRecruiter(id, isShowToRecruiter) {
    const data = {
      id,
      isShowToRecruiter
    };

    return ApiService.edit(ApiUrl.emailTemplateSetShowToRecruiter, data)
      .then(
        action(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            this.getEmailTemplates();
          } else {
            Alert.error(
              response.data.message || Constants.ALERT_SOMETHING_WENT_WRONG
            );
          }
          return Promise.resolve(response.data);
        })
      )
      .catch(
        action(err => {
          return Promise.reject(err);
        })
      );
  },

  newSendTestEmail(data = {}) {
    return ApiService.post(ApiUrl.newSendTestMail, data)
      .then(
        action(response => {
          if (
            response?.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            Alert.success(Constants.ALERT_SUCCESS_SEND_EMAIL);
          } else {
            Alert.error(Constants.ALERT_SOMETHING_WENT_WRONG);
          }
          return Promise.resolve(response.data);
        })
      )
      .catch(action(error => Promise.reject(error)));
  },

  newSendTestAlert(data = {}) {
    return ApiService.post(ApiUrl.sendTestAlert, data)
      .then(
        action(response => {
          if (
            response?.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            Alert.success(Constants.ALERT_SUCCESS_SEND_EMAIL);
          } else {
            Alert.error(Constants.ALERT_SOMETHING_WENT_WRONG);
          }
          return Promise.resolve(response.data);
        })
      )
      .catch(action(error => Promise.reject(error)));
  },

  getIsNameInUse(name) {
    return ApiService.get(
      ApiUrl.getEmailCampaignIsNameInUse + `?name=${encodeURIComponent(name)}&excludeId=${this.id || 0}`,
      "",
      "Failed to get email data"
    )
      .then(
        action(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            return Promise.resolve(response.data);
          } else {
            Alert.error(Constants.ALERT_SOMETHING_WENT_WRONG);
          }
        })
      )
      .catch(action(err => Promise.reject(err)));
  },

  getIsTemplateNameInUse(name) {
    return ApiService.get(
      ApiUrl.getEmailTemplateIsNameInUse + `?name=${name}`,
      "",
      "Failed to get email data"
    )
      .then(
        action(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            return Promise.resolve(response.data);
          } else {
            Alert.error(Constants.ALERT_SOMETHING_WENT_WRONG);
          }
        })
      )
      .catch(action(err => Promise.reject(err)));
  },

  postSaveAsNew(id, name) {
    const data = {
      id: id,
      name: name
    };

    return ApiService.post(ApiUrl.postEmailCampaignSaveAsNew, data)
      .then(
        action(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            !response.data.isError
          ) {
            return Promise.resolve(response.data);
          } else {
            Alert.error(Constants.ALERT_SOMETHING_WENT_WRONG);
          }
        })
      )
      .catch(action(err => Promise.reject(err)));
  },

  // #region Bee Templates

  async handleApiResponse(apiCall, errorContext = "") {
    try {
      const response = await apiCall();
      // Handle Axios response wrapper: { data: { statusCode, result }, status }
      if (
        response.data &&
        typeof response.data === "object" &&
        response.status !== undefined
      ) {
        const apiResponse = response.data;

        // Check if the nested data has statusCode (actual API response)
        if (apiResponse.statusCode !== undefined) {
          if (apiResponse.statusCode === 200) {
            return {
              success: true,
              data:
                apiResponse.result !== undefined
                  ? apiResponse.result
                  : apiResponse.data !== undefined
                  ? apiResponse.data
                  : apiResponse,
              error: null,
              message: apiResponse.message,
              statusCode: apiResponse.statusCode
            };
          } else {
            return {
              success: false,
              data: null,
              error:
                apiResponse.message ||
                `API returned status code: ${apiResponse.statusCode}`,
              statusCode: apiResponse.statusCode
            };
          }
        }

        // Handle Axios response with HTTP status
        if (response.status === 200) {
          return {
            success: true,
            data:
              apiResponse.result !== undefined
                ? apiResponse.result
                : apiResponse.data !== undefined
                ? apiResponse.data
                : apiResponse,
            error: null,
            message: apiResponse.message || "Success",
            statusCode: response.status
          };
        } else {
          return {
            success: false,
            data: null,
            error:
              apiResponse.message ||
              response.statusText ||
              `HTTP ${response.status}`,
            statusCode: response.status
          };
        }
      }

      // Handle direct API response format: { statusCode: 200, result: {...} }
      if (response.statusCode !== undefined) {
        if (response.statusCode === 200) {
          return {
            success: true,
            data:
              response.result !== undefined
                ? response.result
                : response.data !== undefined
                ? response.data
                : response,
            error: null,
            message: response.message,
            statusCode: response.statusCode
          };
        } else {
          return {
            success: false,
            data: null,
            error:
              response.message ||
              `API returned status code: ${response.statusCode}`,
            statusCode: response.statusCode
          };
        }
      }

      // Handle direct data response (assume success if no status code)
      if (
        response.data !== undefined ||
        response.result !== undefined ||
        (response && typeof response === "object")
      ) {
        return {
          success: true,
          data:
            response.result !== undefined
              ? response.result
              : response.data !== undefined
              ? response.data
              : response,
          error: null,
          message: response.message || "Success",
          statusCode: 200
        };
      }

      // Fallback for unexpected response format
      return {
        success: false,
        data: null,
        error: "Unexpected response format",
        statusCode: null
      };
    } catch (error) {
      console.error(`API Error ${errorContext}:`, error);
      return {
        success: false,
        data: null,
        error: error.message || "An unexpected error occurred",
        statusCode: null
      };
    }
  },

  validateRequired(params, requiredFields) {
    for (const field of requiredFields) {
      if (params[field] === undefined || params[field] === null) {
        throw new Error(`Required parameter '${field}' is missing`);
      }
    }
  },

  /**
   * Retrieves Bee templates from external API
   * Based on: https://docs.beefree.io/beefree-sdk/apis/template-catalog-api/templates
   * @param {Object} params - Query parameters for pagination and filtering
   * @returns {Promise<Object>} API response with Bee templates data
   */
  async getBeeTemplatesApi(params = {}) {
    const queryParams = new URLSearchParams();

    // Required parameters
    queryParams.append("template_type", "email");

    // Pagination
    if (params.page) {
      queryParams.append("page", params.page.toString());
    }
    if (params.pagesize) {
      queryParams.append("pagesize", params.pagesize.toString());
    }
    // Category filtering (API expects individual category slugs)
    if (params.categories && params.categories.length > 0) {
      const categorySlugs = params.categories
        .map(cat => {
          const category = emailStore.beeCategories.find(c => c.name === cat);
          return category
            ? category.slug
            : cat.toLowerCase().replace(/\s+/g, "-");
        })
        .filter(slug => slug);

      // Add each category as a separate query parameter
      categorySlugs.forEach(slug => {
        queryParams.append("category", slug);
      });
    }

    // Search filtering
    if (params.search) {
      queryParams.append("search", params.search);
    }

    // Collection filtering
    if (params.collection) {
      queryParams.append("collection", params.collection);
    }

    // Designer filtering
    if (params.designer) {
      queryParams.append("designer", params.designer);
    }

    // Tag filtering
    if (params.tag) {
      queryParams.append("tag", params.tag);
    }

    // Date filtering
    if (params.published_after) {
      queryParams.append("published_after", params.published_after);
    }
    if (params.published_before) {
      queryParams.append("published_before", params.published_before);
    }

    return this.handleApiResponse(async () => {
      const response = await ApiService.get(
        ApiUrl.getBeeTemplates + `?${queryParams.toString()}`
      );

      if (response.data.statusCode !== 200) {
        throw new Error(
          `Bee API error: ${response.status} ${response.statusText}`
        );
      }

      const data = response.data.result;

      // Return data in our expected format
      return {
        statusCode: 200,
        result: {
          items: data.results || [],
          totalCount: data.count || 0,
          next: data.next || null,
          previous: data.previous || null,
          facets: data.facets || {}
        }
      };
    }, "fetching Bee templates");
  },

  /**
   * Retrieves a specific Bee template by ID
   * @param {string} beeTemplateId - The Bee template ID
   * @returns {Promise<Object>} API response with Bee template data
   */
  async getBeeTemplateLandingPageByIdApi(beeTemplateId) {
    this.validateRequired({ beeTemplateId }, ["beeTemplateId"]);

    return this.handleApiResponse(async () => {
      const response = await ApiService.get(
        `${ApiUrl.getBeeTemplateById}${beeTemplateId}?TemplateType=email`
      );

      if (response.data.statusCode !== 200) {
        throw new Error(
          `Bee API error: ${response.status} ${response.statusText}`
        );
      }

      const data = response.data.result;
      return {
        statusCode: 200,
        result: data
      };
    }, "fetching Bee template by ID");
  },

  /**
   * Get Bee templates with server-side filtering
   * Based on: https://docs.beefree.io/beefree-sdk/apis/template-catalog-api/templates
   * @param {Object} params - Query parameters
   * @returns {Promise<Array>} Array of template objects
   */
  getBeeTemplates: async (params = {}) => {
    try {
      emailStore.setBeeTemplatesLoading(true);
      emailStore.setBeeTemplatesError(null);

      // Build API parameters
      const apiParams = {
        page: params.page || 1,
        pagesize: params.pagesize || 20,
        template_type: "email",
        ...params
      };

      // Add category filtering if categories are selected
      if (emailStore.selectedCategories.length > 0) {
        apiParams.categories = emailStore.selectedCategories;
      }

      // Add search filtering if search term exists
      if (emailStore.searchTerm) {
        apiParams.search = emailStore.searchTerm;
      }

      const response = await emailStore.getBeeTemplatesApi(apiParams);

      if (response.success && response.data) {
        const { items, totalCount, next, previous, facets } = response.data;

        // Filter out blank templates and update store
        const filteredItems = (items || []).filter(template => !template.is_blank);
        emailStore.setBeeTemplates(filteredItems);
        emailStore.setBeeTemplatesTotalCount(totalCount || 0);
        emailStore.setBeeTemplatesNext(next);
        emailStore.setBeeTemplatesPrevious(previous);
        emailStore.setBeeTemplatesFacets(facets || {});

        // Update categories from facets if available and categories are empty
        if (
          facets &&
          facets.categories &&
          emailStore.beeCategories.length === 0
        ) {
          const categoriesFromFacets = facets.categories.map(category => ({
            id: category.id || category.slug || category.name,
            name: category.name || category.title,
            slug: category.slug || category.id || category.name,
            count: category.count || 0,
            parent: category.parent || null
          }));

          emailStore.setBeeCategories(categoriesFromFacets);
        }

        // Update current page
        if (params.page) {
          emailStore.setBeeTemplatesPage(params.page);
        }

        return items || [];
      }

      // Handle API error
      const errorMessage = response.error || "Failed to fetch Bee templates";
      emailStore.setBeeTemplatesError(errorMessage);
      console.error("API Error:", errorMessage);
      return [];
    } catch (error) {
      console.error("Error fetching Bee templates:", error);
      emailStore.setBeeTemplatesError(
        error.message || "Failed to fetch templates"
      );
      return [];
    } finally {
      emailStore.setBeeTemplatesLoading(false);
    }
  },

  getBeeTemplateLandingPageById: async id => {
    try {
      const response = await emailStore.getBeeTemplateLandingPageByIdApi(id);

      if (response.success) {
        return response.data;
      }

      throw new Error(
        response.error || "Failed to fetch Bee template landing page"
      );
    } catch (error) {
      console.error("Error fetching Bee template landing page:", error);
      throw error;
    }
  },

  getBeeCategories: async () => {
    try {
      emailStore.setBeeCategoriesLoading(true);
      emailStore.setBeeCategoriesError(null);

      const response = await ApiService.get(
        ApiUrl.getBeeCategories
      );

      if (response.data.statusCode !== 200) {
        throw new Error(
          `Bee API error: ${response.status} ${response.statusText}`
        );
      }

      const data = response.data.result;

      // Handle API response format
      let categories = [];
      if (Array.isArray(data)) {
        categories = data;
      } else if (data.results && Array.isArray(data.results)) {
        categories = data.results;
      } else if (data.categories && Array.isArray(data.categories)) {
        categories = data.categories;
      } else {
        throw new Error("Invalid categories response format");
      }

      // Transform to our format
      const transformedCategories = categories.map(category => ({
        id: category.id || category.slug || category.name,
        name: category.name || category.title,
        slug: category.slug || category.id || category.name,
        count: category.count || 0,
        parent: category.parent || null
      }));

      emailStore.setBeeCategories(transformedCategories);
      return transformedCategories;
    } catch (error) {
      console.error("Error getting categories from API:", error);
      emailStore.setBeeCategoriesError("Failed to load categories");
      emailStore.setBeeCategories([]);
      return [];
    } finally {
      emailStore.setBeeCategoriesLoading(false);
    }
  },

  /**
   * Get templates (server-side filtered by API)
   * No client-side filtering needed - all filtering is done server-side
   * @returns {Array} Array of template objects
   */
  getFilteredTemplates: () => {
    // Templates are already filtered by the API based on selected categories and search term
    return emailStore.beeTemplates;
  }

  // #endregion
});

export default emailStore;
